import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const OutlookIcon = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        style: style,
        className: className,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7.71001 20.87H20.33C21.81 20.87 23 19.67 23 18.2V9.16001C23 8.37001 22.61 7.65001 21.92 7.26001L15.32 3.51001C14.44 3.01001 13.37 3.01001 12.49 3.51001L5.01001 7.81001V18.17C5.01001 19.66 6.22001 20.87 7.71001 20.87Z",
                fill: "#158FDA"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.21 19.16C10.28 18.35 10.79 17.64 11.54 17.32C11.54 17.32 18.37 13.48 21.76 11.5C22.81 10.89 22.99 9.64001 22.99 9.64001V18.17C22.99 19.66 21.78 20.87 20.29 20.87H12.1C11.12 20.87 10.31 20.13 10.21 19.16Z",
                fill: "url(#outlook_a)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M21.5601 7.02002L9.81006 13.51L12.1501 14.93C13.0201 15.46 14.2801 15.74 15.1701 15.24L21.4301 11.73C22.2701 11.26 23.0101 10.49 23.0101 9.15002C23.0101 7.81002 22.0701 7.34002 21.5701 7.02002H21.5601Z",
                fill: "#01459B"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.9801 3.15001C13.4701 3.15001 12.9501 3.28001 12.4901 3.54001L2.56006 9.14001L6.32006 11.42L17.8601 4.91001L15.4601 3.54001C15.0001 3.28001 14.4801 3.14001 13.9701 3.14001L13.9801 3.15001Z",
                fill: "#26AEE9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.8701 4.92004L6.33008 11.43L10.1001 13.72L21.8701 7.23004C21.7801 7.16004 21.6601 7.10004 21.5601 7.04004L17.8701 4.93004V4.92004Z",
                fill: "#0078D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1.92 6.35999H11.17C11.67 6.35999 12.08 6.76999 12.08 7.26999L12.05 16.28C12.05 16.8 11.63 17.22 11.11 17.22H1.96C1.43 17.22 1 16.79 1 16.26L1.03 7.23998C1.03 6.74998 1.43 6.35999 1.91 6.35999H1.92Z",
                fill: "url(#outlook_b)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.87003 10.25C4.09003 9.76996 4.45003 9.36996 4.91003 9.08996C5.42003 8.79996 6.00003 8.64996 6.58003 8.64996C7.13003 8.62996 7.67003 8.75996 8.14003 9.00996C8.59003 9.25996 8.95003 9.62996 9.19003 10.08C9.45003 10.57 9.58003 11.12 9.58003 11.67C9.60003 12.25 9.48003 12.82 9.24003 13.35C9.01003 13.82 8.65003 14.22 8.20003 14.49C8.10003 14.55 7.99003 14.6 7.88003 14.65C7.48003 14.83 7.04003 14.92 6.59003 14.91C6.03003 14.93 5.48003 14.8 4.99003 14.54C4.54003 14.29 4.17003 13.92 3.93003 13.47C3.67003 12.98 3.54003 12.44 3.54003 11.9C3.52003 11.33 3.63003 10.76 3.87003 10.23V10.25ZM5.04003 12.9C5.17003 13.2 5.38003 13.45 5.65003 13.64C5.93003 13.82 6.25003 13.91 6.58003 13.9C6.93003 13.9 7.28003 13.8 7.57003 13.6C7.83003 13.41 8.03003 13.14 8.14003 12.84C8.26003 12.5 8.32003 12.15 8.31003 11.79C8.31003 11.43 8.24003 11.07 8.12003 10.73C8.01003 10.42 7.81003 10.16 7.55003 9.95996C7.26003 9.75996 6.91003 9.65996 6.56003 9.67996C6.22003 9.67996 5.89003 9.77996 5.61003 9.96996C5.34003 10.17 5.14003 10.43 5.02003 10.74C4.76003 11.44 4.77003 12.21 5.05003 12.9H5.04003Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "outlook_a",
                        x1: "13.2052",
                        y1: "17.6716",
                        x2: "21.7876",
                        y2: "14.0572",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#4DE2FB"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#28AEE8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "outlook_b",
                        x1: "6.13663",
                        y1: "5.56998",
                        x2: "6.13277",
                        y2: "16.4219",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#1582D8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#0A64CC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
